import { ShareIcon } from '@heroicons/react/16/solid';
import React from 'react';

import {
  AccentButton,
  Button,
  PrimaryButton,
  SecondaryButton,
} from '../components/Button';
import Card from '../components/Card';

const Playground: React.FC = () => {
  return (
    <div className="w-full">
      <h1 className="mb-4 text-2xl font-bold">Playground</h1>
      <div className="grid grid-cols-1 gap-4">
        {/* Cards */}
        <div className="bg-gray-100 p-4">
          <h2 className="mb-2 text-lg font-bold">Cards</h2>
          <Card className="h-48 w-96">
            <h3 className="text-base">Simple Card Container</h3>
          </Card>
        </div>

        {/* Buttons */}
        <div className="bg-gray-100 p-4">
          <h2 className="mb-2 text-lg font-bold">Buttons</h2>
          <div className="flex flex-row">
            <Button text={'Simple Button'} className="mx-2" />
            <PrimaryButton text={'Primary Button'} className="mx-2" />
            <SecondaryButton text={'Secondary Button'} className="mx-2" />
            <AccentButton text={'Accent Button'} className="mx-2" />
            <Button text={'Simple Button'} className="mx-2">
              <ShareIcon className="mr-1 size-6" />
              <span>Button w/ Icon</span>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Playground;
